/* eslint-disable react/react-in-jsx-scope */
import { useState, useContext } from 'react'
// import { InitialState, UserReducer } from '../reducers/UserReducer';
// import { UserContext, UserDispatchContext } from '../contexts/testContext';
import { UserProvider, useUserContext, UserContext, UserDispatchContext } from '../contexts/testContext';
import Test1 from './test1';
import Test2 from './test2';
import Index from '../components/index'

const Test = () => {
    // const [state, dispatch] = useReducer(UserReducer, InitialState);
    const userCon = useUserContext();

    return (
        <div className="p-20">
           

            <UserProvider>
                {userCon?.isLogin? <Index /> :
                <>
                    <h1>Day off in Kyoto</h1>
                    <Test1>
                        <Test2> Test2 </Test2>
                    </Test1>
                </>
                }
            </UserProvider>
        </div>
    )
}

export default Test